import React from "react";
import ReactTable from "react-table";
import Select from 'react-select';
import DatePicker from "react-datepicker";
import { Link } from "react-router-dom";
import '../../stylesheets/shared/react-table.css';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import { impactStatementActionCreators } from '../../stores/lis-impact-statement-store';
import { sessionActionCreators } from '../../stores/lis-session-store';
import { cancelRequest } from '../../services/request.service';
import { navActionCreators } from "../../stores/lis-nav-store";
import { committeeActionCreators } from "../../stores/lis-committee-store";
import { billActionCreators } from "../../stores/lis-legislation-store";

const selectStyle = {
    container: styles => ({
        ...styles,
        minWidth: '150px',
        height: "30px"
    }),
    control: styles => ({
        ...styles,
        minHeight: '0px',
        padding: '2px 4px 0px 4px !important',
        height: "30px"
    }),
    valueContainer: styles => ({
        ...styles,
        padding: 0,
        height: "30px"
    }),
    input: styles => ({
        ...styles,
        fontSize: '0.8em',
        lineHeight: 'normal',
        height: "30px"
    }),
    singleValue: styles => ({
        ...styles,
        fontSize: '0.8em',
        marginTop: "1px"
    }),
    placeholder: styles => ({
        ...styles,
        fontSize: '0.8em'
    }),
    option: styles => ({
        ...styles,
        fontSize: '0.8em'
    }),
    dropdownIndicator: styles => ({
        ...styles,
        padding: '0px 0px 0px 4px'
    }),
    menu: provided => ({
        ...provided,
        whiteSpace: 'nowrap',
        width: 'fit-content'
    }),
    indicatorsContainer: styles => ({
        ...styles,
        marginTop: "-5px"
    })
};

const impactStatementOptions = [
    { label: "All", value: "all" },
    { label: "Both", value: "both" },
    { label: "Removed", value: "removed" },
    { label: "Revised", value: "revised" }
]

class ImpactStatementGridComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            billNumber: "",
            calendarDate: null,
            status: "",
            committee: "",
            subcommittee: "",
            isLoaded: false,
            billStatusReferences: [],
            currently: true,
            billNumSearching: false,
            selectedSession: "",
            sessionOptions: [],
            impactStatement: { label: "All", value: "all" },
            impactStatements: [],
            showApprovalModal: false
        };

        this.fetchTableData = this.fetchTableData.bind(this);
        this.handleBillNumberChange = this.handleBillNumberChange.bind(this);
        this.handleCalendarDateChange = this.handleCalendarDateChange.bind(this);
        this.handleStatusChange = this.handleStatusChange.bind(this);
        this.handleCommitteeChange = this.handleCommitteeChange.bind(this);
        this.handleSubcommitteeChange = this.handleSubcommitteeChange.bind(this);
        this.handleCurrentlyToggle = this.handleCurrentlyToggle.bind(this);
        this.handleSessionChange = this.handleSessionChange.bind(this);
        this.handleImpactStatementChange = this.handleImpactStatementChange.bind(this);
        this.toggleApprovalModal = this.toggleApprovalModal.bind(this);
        this.toggleRemovalRequest = this.toggleRemovalRequest.bind(this);
    };

    componentDidMount() {
        this.props.actions.getSessionList()
            .then(() => {
                let sessionOptions = [...this.props.session.sessionList];
                let selectedSession = '';
                sessionOptions.forEach(session => {
                    session.label = session.SessionYear + ' ' + session.DisplayName;
                    session.value = session.SessionID;
                    if (session.IsDefault) {
                        selectedSession = session;
                    }
                });
                this.setState({
                    sessionOptions: sessionOptions.reverse(),
                }, () => {
                    let committeeParams = "sessionCode=" + this.props.session.selectedSession.SessionCode + "&includeSubCommittees=true"
                    this.props.actions.getCommitteeList(committeeParams)
                    this.props.actions.getBillStatusCategoryReferences().then(() => {
                        let billStatusReferences = [...this.props.bills.billStatusCategoryReferences];
                        billStatusReferences.forEach(ref => {
                            ref.label = ref.Name
                            ref.value = ref.LegislationCategoryID
                        });
                        this.setState({
                            billStatusReferences
                        }, () => {
                            if (this.props.impact.impactStatementBill !== "") {
                                let selectedSession = this.props.session.selectedSession.SessionCode !== "" ? this.props.session.selectedSession : this.state.sessionOptions.find(x => x.IsDefault === true)
                                selectedSession.label = selectedSession.SessionYear + " " + selectedSession.DisplayName;
                                selectedSession.value = selectedSession.SessionCode;

                                this.setState({
                                    selectedSession: selectedSession,
                                    billNumber: this.props.impact.impactStatementBill
                                }, () => {
                                    localStorage.setItem("IMPACT_PARAMS", JSON.stringify(
                                        {
                                            billNumber: this.state.billNumber,
                                            impactStatement: this.state.impactStatement,
                                            committee: this.state.committee,
                                            subcommittee: this.state.subcommittee,
                                            status: this.state.status,
                                            calendarDate: this.state.calendarDate,
                                            selectedSession: this.state.selectedSession,
                                            currently: this.state.currently,
                                            selectedSession: this.state.selectedSession
                                        }
                                    ))

                                    this.fetchTableData();
                                })
                            } else {
                                let state = JSON.parse(localStorage.getItem("IMPACT_PARAMS"))

                                if (state) {
                                    for (const [key, value] of Object.entries(state)) {
                                        this.setState({
                                            [key]: key.toLowerCase().includes("date")
                                                ? value
                                                    ? moment(value)
                                                    : ""
                                                : value
                                        })
                                    }

                                    this.fetchTableData();
                                } else {
                                    let selectedSession = this.props.session.selectedSession.SessionCode !== "" ? this.props.session.selectedSession : this.state.sessionOptions.find(x => x.IsDefault === true)
                                    selectedSession.label = selectedSession.SessionYear + " " + selectedSession.DisplayName;
                                    selectedSession.value = selectedSession.SessionCode;

                                    this.setState({
                                        selectedSession: selectedSession
                                    }, () => {
                                        this.fetchTableData();
                                    })
                                }
                            }
                        })
                    });
                });
            })
    }

    componentWillUnmount() {
        cancelRequest();
    }

    toggleApprovalModal(fileId, impactStatement, hacStatusID, sfacStatusID, chamberCode, fileUrl) {
        this.setState({
            showApprovalModal: this.state.showApprovalModal ? false : { fileId: fileId, impactStatement: impactStatement, chamberCode: chamberCode, hacStatusID: hacStatusID, sfacStatusID: sfacStatusID, fileUrl: fileUrl }
        })
    }

    toggleRemovalRequest(response, chamberCode) {
        let body = {
            HACStatusID: chamberCode === "H" ? response : this.state.showApprovalModal.hacStatusID,
            SFACStatusID: chamberCode === "S" ? response : this.state.showApprovalModal.sfacStatusID,
            FileID: this.state.showApprovalModal.fileId,
            FileURL: this.state.showApprovalModal.fileUrl
        }

        this.props.actions.toggleImpactStatementRemoval(body)
            .then(() => {
                this.fetchTableData();
                this.props.actions.makeToast([{ message: "Impact Statement Removal Response Received", type: "success" }]);

                this.setState({
                    showApprovalModal: false
                })
            })
            .catch(err => {
                console.log(err)
                this.props.actions.makeToast([{ message: "Impact Statement Removal Response Failed", type: "failure" }]);
            })
    }

    fetchTableData() {
        this.setState({
            isLoaded: false
        }, () => {
            let request = {
                LegislationNumber: this.state.billNumber,
                ImpactFilter: this.state.impactStatement ? this.state.impactStatement.value : "all",
                CommitteeID: this.state.subcommittee ? this.state.subcommittee.CommitteeID : this.state.committee ? this.state.committee.CommitteeID : "",
                Status: this.state.status ? this.state.status.value : "",
                CalendarDate: this.state.calendarDate ? this.state.calendarDate : null,
                SessionCode: this.state.selectedSession ? this.state.selectedSession.SessionCode : this.props.session.selectedSession.SessionCode,
                Currently: this.state.currently,
                SessionCode: this.state.selectedSession.SessionCode
            }

            this.props.actions.getImpactStatements(request)
                .then(() => {
                    this.setState({
                        isLoaded: true,
                        impactStatements: this.props.impact.impactStatements
                    })
                })

            localStorage.setItem("IMPACT_PARAMS", JSON.stringify(
                {
                    billNumber: this.state.billNumber,
                    impactStatement: this.state.impactStatement,
                    committee: this.state.committee,
                    subcommittee: this.state.subcommittee,
                    status: this.state.status,
                    calendarDate: this.state.calendarDate,
                    selectedSession: this.state.selectedSession,
                    currently: this.state.currently,
                    selectedSession: this.state.selectedSession
                }
            ))
        })
    }

    handleBillNumberChange(e) {
        this.setState({
            billNumber: e.target.value
        })
    }

    handleCalendarDateChange(value) {
        this.setState({
            calendarDate: value
        }, () => {
            this.fetchTableData()
        })
    }

    handleCurrentlyToggle() {
        this.setState({
            currently: !this.state.currently
        }, () => {
            this.fetchTableData()
        })
    }

    handleImpactStatementChange(value) {
        this.setState({
            impactStatement: value
        }, () => {
            this.fetchTableData()
        })
    }

    handleSessionChange(value) {
        this.setState({
            selectedSession: value
        }, () => {
            this.fetchTableData()
        })
    }

    handleStatusChange(value) {
        this.setState({
            status: value
        }, () => {
            this.fetchTableData()
        })
    }

    handleCommitteeChange(value) {
        this.setState({
            committee: value
        }, () => {
            if (!this.state.committee) {
                this.handleSubcommitteeChange(null)
            }
            this.fetchTableData()
        })
    }

    handleSubcommitteeChange(value) {
        this.setState({
            subcommittee: value
        }, () => {
            this.fetchTableData()
        })
    }

    render() {
        const hacAdmin = this.props.login.userClaims.roles.find(x => x === "HACAdmin")
        const sfacAdmin = this.props.login.userClaims.roles.find(x => x === "SFACAdmin")

        const alerts = this.state.impactStatements?.map(x => {
            return ((hacAdmin && x.HACStatusID === 0) || (sfacAdmin && x.SFACStatusID === 0)) ? { impactStatement: x.ImpactStatement, fileID: x.FileID, hacStatusID: x.HACStatusID, sfacStatusID: x.sfacAdmin, fileUrl: x.FileURL } : null
        })

        return (
            <div className="impact-statement-management">
                {alerts.filter(x => x).length > 0 && (hacAdmin || sfacAdmin) &&
                    <div className="alert alert-impact mb-0" style={{ marginBottom: "15px" }}>
                        <p style={{ fontWeight: "bold", fontSize: "21px" }}>ALERT!</p>
                        <p style={{ fontWeight: "bold", fontSize: "15px" }}>Request to remove the following impact statement(s):</p>
                        {alerts.map((x, i) => {
                            return x ? <p key={"alert-" + i} style={{ cursor: "pointer", fontSize: "15px" }} onClick={() => this.toggleApprovalModal(x.fileID, x.impactStatement, x.hacStatusID, x.sfacStatusID, hacAdmin ? "H" : "S", x.fileUrl)}>{x.impactStatement}</p> : null
                        })}
                    </div>
                }
                <div className="header-half">
                    <h1>Fiscal Impact Statements</h1>
                </div>
                <div className="toolbar impact-statement-toolbar dlas-forms">
                    <div className="is-filter-wrapper">
                        <label>Session</label>
                        <Select
                            id="sessionDropdown"
                            value={this.state.selectedSession}
                            onChange={this.handleSessionChange}
                            styles={selectStyle}
                            options={this.state.sessionOptions}
                            classNamePrefix='no-width-dropdown-input'
                        />
                    </div>
                    <div className="is-filter-wrapper">
                        <label>Bill #</label>
                        <input
                            id={"bill-num-input"}
                            style={{ width: "100%" }}
                            onChange={(e) => this.handleBillNumberChange(e)}
                            value={this.state.billNumber}
                            onKeyDown={e => {
                                if (e.key === "Enter") {
                                    this.fetchTableData()
                                }
                            }}
                        />
                    </div>
                    <div className="is-filter-wrapper">
                        <label>Impact Statement</label>
                        <Select
                            value={this.state.impactStatement}
                            onChange={this.handleImpactStatementChange}
                            styles={selectStyle}
                            options={impactStatementOptions}
                            classNamePrefix='no-width-dropdown-input'
                            isClearable
                        />
                    </div>
                    <div className="is-filter-wrapper">
                        <label>Calendar Date</label>
                        <DatePicker
                            selected={this.state.calendarDate}
                            onChange={this.handleCalendarDateChange}
                            wrapperClassName="statement-datepicker"
                            isClearable
                        />
                    </div>
                    <div className="is-filter-wrapper">
                        <label>Status</label>
                        <Select
                            value={this.state.status}
                            onChange={this.handleStatusChange}
                            styles={selectStyle}
                            options={this.state.billStatusReferences}
                            classNamePrefix='no-width-dropdown-input'
                            isClearable
                        />
                    </div>
                    <div style={{ borderRight: "1px solid #CCC", height: "100%" }} />
                    <div className="is-filter-wrapper">
                        <label>Committee</label>
                        <Select
                            value={this.state.committee}
                            onChange={this.handleCommitteeChange}
                            styles={selectStyle}
                            classNamePrefix='no-width-dropdown-input'
                            options={[...this.props.committee.committeeList.filter(x => !x.ParentCommitteeID)]}
                            getOptionLabel={o => o.ChamberCode + " - " + o.Name}
                            getOptionValue={o => o.CommitteeNumber}
                            isClearable
                        />
                    </div>
                    <div className="is-filter-wrapper">
                        <label>Subcommittee</label>
                        <Select
                            value={this.state.committee ? this.state.subcommittee : ""}
                            onChange={this.handleSubcommitteeChange}
                            styles={selectStyle}
                            classNamePrefix='no-width-dropdown-input'
                            isDisabled={!this.state.committee || this.state.committee === ""}
                            options={this.state.committee ? [...this.props.committee.committeeList.filter(x => x.ParentCommitteeID === this.state.committee.CommitteeID)] : []}
                            getOptionLabel={o => o.Name}
                            getOptionValue={o => o.CommitteeNumber}
                            isClearable
                        />
                    </div>
                    <div className="is-filter-wrapper" style={{ display: "grid", gridTemplateRows: "1fr 1fr" }}>
                        <label>Currently</label>
                        <div className="toggle-switch" onClick={() => this.handleCurrentlyToggle()} style={{ marginTop: "3px" }}>
                            <input id="se-currently-toggle" checked={this.state.currently} type="checkbox" style={{ width: "auto" }} onChange={() => { }} />
                            <span className="slider"></span>
                        </div>
                    </div>
                </div>
                {this.state.showApprovalModal &&
                    <div className="removal-modal">
                        <div className="removal-modal-header">
                            <h3>Removal Request</h3>
                            <div style={{ width: "100%" }} />
                            <i className="icon white-x" onClick={() => this.toggleApprovalModal()} />
                        </div>
                        <p>Request to remove</p>
                        <p>{this.state.showApprovalModal.impactStatement}</p>
                        <div className="removal-request-buttons">
                            <button className="button primary reject" onClick={() => this.toggleRemovalRequest(2, hacAdmin ? "H" : "S")}>Reject Removal</button>
                            <button className="button primary approve" onClick={() => this.toggleRemovalRequest(1, hacAdmin ? "H" : "S")}>Approve Removal</button>
                        </div>
                        <div className="removal-request-footer">
                            <button className="button secondary" onClick={() => this.toggleApprovalModal()}>Cancel</button>
                        </div>
                    </div>
                }
                <ReactTable
                    loading={!this.state.isLoaded}
                    data={this.state.impactStatements}
                    resizable={false}
                    columns={[
                        {
                            Header: "",
                            id: "billDetailsLinks",
                            width: 30,
                            Cell: row => {
                                return <Link className="icon bill-details-link" title="Bill Details" to={"/bill-details/" + this.state.selectedSession.SessionCode + "/" + row.original.LegislationNumber}></Link>
                            }
                        },
                        {
                            Header: "Doc #",
                            accessor: "DocumentCode",
                            id: "documentNumber",
                            width: 125,
                            Cell: row => {
                                return <Link to={"/bill-details/" + this.state.selectedSession.SessionCode + "/" + row.original.LegislationNumber + "/text/" + row.original.DocumentCode}>{row.original.DocumentCode}</Link>
                            }
                        },
                        {
                            Header: "Agency",
                            accessor: "Agency",
                            id: "agencyName",
                            width: 100
                        },
                        {
                            Header: "",
                            id: "flag",
                            width: 30,
                            Cell: row => {
                                return row.original.IsRemoved ? <span className="icon flag" /> : row.original.IsRevised ? <span className="icon orange-flag" /> : null
                            }
                        },
                        {
                            Header: "Impact Statement",
                            accessor: "ImpactStatement",
                            id: "impactStatement",
                            Cell: row => {
                                return <a href={row.original.FileURL}>{row.original.IsRemoved && row.original.IsRevised ? row.original.ImpactStatement.replace(")", " - Revised - Removed)") : row.original.IsRemoved ? row.original.ImpactStatement.replace(")", " - Removed)") : row.original.IsRevised ? row.original.ImpactStatement.replace(")", " - Revised)") : row.original.ImpactStatement}</a>
                            }
                        },
                        {
                            Header: "Status",
                            accessor: "StatusDisplayName",
                            id: "status",
                            width: 225
                        },
                        {
                            Header: "H",
                            id: "house",
                            width: 30,
                            Cell: row => {
                                return row.original.HACStatusID === 0
                                    ? <span className="icon circle-exclamation" onClick={() => { hacAdmin && this.toggleApprovalModal(row.original.FileID, row.original.ImpactStatement, row.original.HACStatusID, row.original.SFACStatusID, "H", row.original.FileURL) }} />
                                    : row.original.HACStatusID === 1
                                        ? <span className="icon checkmark-green" onClick={() => { hacAdmin && row.original.SFACStatusID !== 1 && this.toggleApprovalModal(row.original.FileID, row.original.ImpactStatement, row.original.HACStatusID, row.original.SFACStatusID, "H", row.original.FileURL) }} />
                                        : row.original.HACStatusID === 2
                                            ? <span className="icon blocked" onClick={() => { hacAdmin && this.toggleApprovalModal(row.original.FileID, row.original.ImpactStatement, row.original.HACStatusID, row.original.SFACStatusID, "H", row.original.FileURL) }} />
                                            : null
                            }
                        },
                        {
                            Header: "S",
                            id: "senate",
                            width: 30,
                            Cell: row => {
                                return row.original.SFACStatusID === 0
                                    ? <span className="icon circle-exclamation" onClick={() => { sfacAdmin && this.toggleApprovalModal(row.original.FileID, row.original.ImpactStatement, row.original.HACStatusID, row.original.SFACStatusID, "S", row.original.FileURL) }} />
                                    : row.original.SFACStatusID === 1
                                        ? <span className="icon checkmark-green" onClick={() => { sfacAdmin && row.original.HACStatusID !== 1 && this.toggleApprovalModal(row.original.FileID, row.original.ImpactStatement, row.original.HACStatusID, row.original.SFACStatusID, "S", row.original.FileURL) }} />
                                        : row.original.SFACStatusID === 2
                                            ? <span className="icon blocked" onClick={() => { sfacAdmin && this.toggleApprovalModal(row.original.FileID, row.original.ImpactStatement, row.original.HACStatusID, row.original.SFACStatusID, "S", row.original.FileURL) }} />
                                            : null
                            }
                        }
                    ]}
                    defaultPageSize={20}
                    pageSizeOptions={[5, 10, 15, 20, 25, 50, 100]}
                    className="committee-table -striped -highlight"
                    minRows={5}
                />
            </div>
        );
    }
}

const ImpactStatementManagementGrid = connect(
    (state) => {
        const { session, nav, impact, committee, bills, login } = state;
        return {
            session,
            nav,
            impact,
            committee,
            bills,
            login
        }
    },
    (dispatch) => {
        return {
            actions: bindActionCreators(Object.assign({}, sessionActionCreators, navActionCreators, impactStatementActionCreators, committeeActionCreators, billActionCreators), dispatch)
        }
    }
)(ImpactStatementGridComponent)


export default ImpactStatementManagementGrid;
